let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("71lfh")).then(() => parcelRequire('eJPd3'));